import { voucherApi } from "@/shared/core-vouchers";
import { trackEvent } from "@/utils/firebase/analytics";

export const downloadPdfVoucher = async (id: string, fileName?: string) => {
  const voucherDocument = await voucherApi.getVoucherPDF(id);

  const pdfURL = URL.createObjectURL(voucherDocument);
  const link = document.createElement("a");
  link.href = pdfURL;
  link.download = fileName || `voucher-${id}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(pdfURL);

  trackEvent("export", { type: "pdf", module: "vouchers", voucher_id: id });
};

export const downloadPdfVouchers = async (ids: string[]) => {
  const document_ = await voucherApi.getVouchersPDF(ids);

  const pdfURL = URL.createObjectURL(document_);
  const link = document.createElement("a");
  link.href = pdfURL;
  link.download = `vales-${ids.length}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(pdfURL);

  trackEvent("export", { type: "pdf", module: "vouchers", count: ids.length });
};
